import Vue from "vue";
import i18n from "@/lib/i18n";
import axios from "axios";
import * as Sentry from "@sentry/browser";
import "@/../node_modules/noty/lib/noty.css";
import "@/../node_modules/noty/lib/themes/metroui.css";
import Noty from "noty";

var lastNoty = null;

const notifyError = (msg, force) => {
  // Only show error when forced or when last error is closed
  if (force || !lastNoty || lastNoty.closed) {
    lastNoty = new Noty({
      theme: "metroui",
      type: "error",
      timeout: 60000,
      text: msg,
    });
    if(process.browser) {
      lastNoty.show();
    }
  }
};

export const handleAxiosErrors = () => {
  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      // the request was made but no response was received
      if (!error.response) {
        notifyError(i18n.t("global.network_error"));
      }
      return Promise.reject(error);
    }
  );
};

export const handleAppErrors = () => {
  // Global handler
  var handleError = err => {
    let sw = false;
    // Copied from "isError" from @sentry/utils/esm/is.js
    // We can't import that function because SSR, when built, doesn't know how to parse that file
    switch (Object.prototype.toString.call(err)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      sw = true;
      break;
    default:
      try {
        sw = err instanceof Error;
      } catch (_) {
        sw = false;
      }
    }
    if (sw) {
      Sentry.captureException(err);
    }
  };

  // Subscribe to errors
  if (process.browser) {
    window.addEventListener("error", event => {
      handleError(event.error);
      return false;
    });
    window.addEventListener("unhandledrejection", event => {
      handleError(event.reason);
      return false;
    });
  }
  Vue.config.errorHandler = err => {
    handleError(err);
    // eslint-disable-next-line no-console
    console.error(err);
  };
};
